import { useDispatch, useSelector } from 'react-redux';
import { BRANDS } from '../brands';
import { setBrandFilter, BRAND_FILTER_ALL } from '../store/shownDataSlice';

// Dashboard-wide choice of which company's queries and jobs are shown:
// all of them, only ABuss or only TrioBuss.
const OPTIONS = [
    { id: BRAND_FILTER_ALL, name: 'Kõik', color: '#286ebe' },
    ...Object.values(BRANDS).map(b => ({ id: b.id, name: b.name, color: b.color })),
];

function BrandFilter() {
    const dispatch = useDispatch();
    const brandFilter = useSelector((state) => state.shownData.brandFilter);

    return (
        <div className="row center-cross" role="group" aria-label="Brändi filter" style={{ gap: 0 }}>
            {OPTIONS.map((option, i) => {
                const active = option.id === brandFilter;
                return (
                    <button
                        key={option.id}
                        type="button"
                        onClick={() => dispatch(setBrandFilter(option.id))}
                        aria-pressed={active}
                        style={{
                            padding: '6px 14px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            color: active ? '#fff' : '#333',
                            backgroundColor: active ? option.color : '#fff',
                            border: '1px solid #bbb',
                            borderLeftWidth: i === 0 ? 1 : 0,
                            borderRadius: i === 0 ? '4px 0 0 4px' : (i === OPTIONS.length - 1 ? '0 4px 4px 0' : 0),
                        }}
                    >
                        {option.name}
                    </button>
                );
            })}
        </div>
    );
}

export default BrandFilter;
